import KpiTiles from './KpiTiles';
import ClaimsTable from './ClaimsTable';
import EnrichedTimeline from './EnrichedTimeline';
import MilestoneTimeline from './MilestoneTimeline';
import BadgeGroup from './BadgeGroup';
import Callout from './Callout';
import OpsBriefPanel from '../../zoeAssistant/OpsBriefPanel';
import type { PresentationBlock } from '../../../types/investigator';

interface PresentationRendererProps {
  blocks: PresentationBlock[];
}

export default function PresentationRenderer({ blocks }: PresentationRendererProps) {
  if (blocks.length === 0) return null;

  return (
    <div className="space-y-4">
      {blocks.map((block, i) => {
        switch (block.type) {
          case 'ops_brief':
            return <OpsBriefPanel key={i} block={block} />;
          case 'kpi_group':
            return <KpiTiles key={i} block={block} />;
          case 'table':
            return <ClaimsTable key={i} block={block} />;
          case 'timeline':
            return <EnrichedTimeline key={i} block={block} />;
          case 'milestone_timeline':
            return <MilestoneTimeline key={i} block={block} />;
          case 'badge_group':
            return <BadgeGroup key={i} block={block} />;
          case 'callout':
            return <Callout key={i} block={block} />;
          default:
            return null;
        }
      })}
    </div>
  );
}

export { KpiTiles, ClaimsTable, EnrichedTimeline, MilestoneTimeline, BadgeGroup, Callout };
